import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithTreasure = () => {
  return (
    <KpopStudyPageTemplate
      groupName="TREASURE"
      groupNameDisplay="TREASURE"
      fandomName="Treasure Makers"
      seoTitle="Study With TREASURE - TREASURE Study Rooms"
      seoDescription="Study with TREASURE fans worldwide. Join Treasure Makers in virtual study rooms with TREASURE playlists."
      seoKeywords="study with treasure, treasure study room, treasure maker study, kpop study room"
      canonicalUrl="/study-with-treasure/"
      heroDescription="Join a global community of Treasure Makers who combine their passion for TREASURE with productive study sessions."
      aboutContent={
        <>
          <p>
            <a href="https://yg-treasure.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">TREASURE</a> is a South Korean boy band formed by <a href="https://www.ygfamily.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YG Entertainment</a> through the survival show YG Treasure Box in 2020.
          </p>
          <p>
            TREASURE's fanbase, known as Treasure Maker (TEUME), creates precious moments with the group. Follow them on <a href="https://www.instagram.com/yg_treasure_official/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/YG_TREASURE" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@TREASURE" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          TREASURE fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/3KonOYiLsU53m4yT7EpNl0" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">TREASURE's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "TREASURE Study Playlists", desc: "Curated playlists featuring TREASURE's music to keep you motivated." },
        { title: "Connect with TEUME", desc: "Meet fellow Treasure Makers from around the world who share your passion." },
        { title: "Precious Study Rooms", desc: "Study rooms with TREASURE-inspired aesthetics and energy." },
        { title: "24/7 Sessions", desc: "Study anytime with other Treasure Makers worldwide." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of TREASURE can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://yg-treasure.com/" },
        { name: "YouTube", url: "https://www.youtube.com/@TREASURE" },
        { name: "Instagram", url: "https://www.instagram.com/yg_treasure_official/" },
        { name: "X (Twitter)", url: "https://twitter.com/YG_TREASURE" },
        { name: "Spotify", url: "https://open.spotify.com/artist/3KonOYiLsU53m4yT7EpNl0" },
      ]}
      youtubeVideos={[
        { id: "1-bA8dHm67U", title: "TREASURE - HELLO M/V" },
        { id: "tQRPP8-Shuk", title: "TREASURE - JIKJIN M/V" },
        { id: "s5kJ7HpChJ8", title: "TREASURE - BONA BONA M/V" },
        { id: "IUjZ1fMrLnM", title: "TREASURE - KING KONG M/V" },
        { id: "dTVGMy4urLY", title: "TREASURE - BOY M/V" },
        { id: "ViDDPjUBEYI", title: "TREASURE - DARARI M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@TREASURE"
      youtubeChannelName="TREASURE"
    />
  );
};

export default StudyWithTreasure;
